import React from 'react'
import { Box } from '@mui/material'

function TextBlock({id,type,properties,}) {
  const htmlTag = properties.htmlTag || 'p';
  const useStrong = properties.useStrong || false;
  
  const content = properties.content || 'Your text content here...';
  
  return (
     <Box sx={{
           padding:  `${properties.padding.top}px ${properties.padding.right}px ${properties.padding.bottom}px ${properties.padding.left}px`,
           margin:  `${properties.margin.top}px ${properties.margin.right}px ${properties.margin.bottom}px ${properties.margin.left}px`,
           backgroundColor: properties.backgroundColor || 'transparent',
        }}>
     <Box
            component={htmlTag}
            sx={{
              textAlign: properties.textAlign || 'left',
              color: properties.color || '#000000',
              fontSize: properties.fontSize || '16px',
              fontWeight: properties.fontWeight || 'normal',
              fontFamily: properties.fontFamily || 'Arial, sans-serif',
              textDecoration: properties.textDecoration || 'none',
              lineHeight: properties.lineHeight || '1.5px',
              whiteSpace: htmlTag === 'pre' ? 'pre-wrap' : 'pre-wrap'
            }}
           
          >
            {useStrong ? <strong>{content}</strong> : content}
          </Box>
      </Box>
  )
}

export default TextBlock